import script from "./ProjectCalculation.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectCalculation.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectCalculation.vue?vue&type=style&index=0&id=5d983ae1&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d983ae1"]])

export default __exports__